import {
  FolderList,
  FolderItem,
  WrapperProfile,
  Username,
  RecentChatItem,
  RecentChats,
} from "./styled";
import { ReactComponent as AddIcon } from "../../assets/add.svg";
import { ReactComponent as RecentIcon } from "../../assets/recent.svg";
import { ReactComponent as SettingIcon } from "../../assets/setting.svg";
import { ReactComponent as LogoutIcon } from "../../assets/logout.svg";
import { ReactComponent as CalendarIcon } from "../../assets/calendar.svg";
import { ReactComponent as ProfileIcon } from "../../assets/user.svg";
import defaultAvatar from "../../assets/default_avatar.png";
import { useCallback, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../store";
import { getHistoryThunk } from "../../store/actions/chat.action";
import { useTopic } from "../../context/topicContext";
import { topics } from "../../constants/topics";
import { useNavigate } from "react-router-dom";
import { logout } from "../../store/actions/auth.action";
import { Tooltip, Dropdown } from "antd";

interface Props {
  openSidebar: boolean;
  closeAfterClicked?: boolean;
  setOpenSidebar: (value: React.SetStateAction<boolean>) => void;
}

const SidebarContent = ({
  openSidebar,
  closeAfterClicked,
  setOpenSidebar,
}: Props) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const features = [
    {
      name: "Booking Hotel",
      icon: <CalendarIcon width={22} height={22} />,
      expandDisable: false,
      func: () => {
        navigate("booking");
      },
    },
    {
      name: "New Chat",
      icon: <AddIcon width={22} height={22} />,
      expandDisable: false,
      func: () => {
        navigate(`${topics.find((t) => t.id === parseInt(topic))?.route}`);
      },
      topicRequired: true,
    },
    {
      name: "Recents",
      icon: <RecentIcon width={22} height={22} />,
      expandDisable: true,
      func: () => toggleSidebar(),
      topicRequired: true,
    },
  ];
  const { me, userExtendData } = useAppSelector((state) => state.authReducer);
  const { recentsChat } = useAppSelector((state) => state.chatReducer);
  const { topic, setTopic } = useTopic();

  const fecthRecentSearch = async () => {
    if (!topic) return;

    try {
      await dispatch(
        getHistoryThunk({ bookingType: parseInt(topic), page: 1 })
      ).unwrap();
    } catch (e) {}
  };

  const toggleSidebar = () => {
    setOpenSidebar(!openSidebar);
  };

  const handleLogout = async () => {
    setTopic("");
    await dispatch(logout());
  };

  const handleAction = useCallback(
    (action: any) => {
      if (!closeAfterClicked) {
        action?.();
        return;
      }

      toggleSidebar();
      action?.();
    },
    [toggleSidebar, closeAfterClicked]
  );

  const menuItems = [
    {
      key: "profile",
      label: (
        <span
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            color: "white",
          }}
        >
          <ProfileIcon width={16} height={16} />
          My Profile
        </span>
      ),
      onClick: () => handleAction(() => navigate("/profile")),
    },
    {
      key: "logout",
      label: (
        <span
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            color: "white",
          }}
        >
          <LogoutIcon width={16} height={16} />
          Logout
        </span>
      ),
      onClick: () => handleAction(handleLogout),
    },
  ];

  useEffect(() => {
    fecthRecentSearch();
  }, [topic]);

  return (
    <>
      {topic && (
        <FolderList isOpen={openSidebar}>
          {features
            .filter((folder) => !folder.topicRequired || topic)
            .map((folder, index) => (
              <Tooltip
                key={index}
                title={!openSidebar ? folder.name : undefined}
                placement="right"
              >
                <FolderItem
                  onClick={() => handleAction(() => folder.func())}
                  expandDisable={folder.expandDisable && openSidebar}
                >
                  {openSidebar ? folder.name : folder.icon}
                </FolderItem>
              </Tooltip>
            ))}
          {openSidebar && Object.keys(recentsChat).length > 0 && (
            <div
              style={{ gap: "8px", display: "flex", flexDirection: "column" }}
            >
              <div
                style={{
                  color: "#a1a1aa",
                  fontSize: "14px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Recent Chats
              </div>
              <RecentChats>
                {recentsChat.items.map((item) => (
                  <RecentChatItem
                    to={`${
                      topics.find((t) => t.id === parseInt(topic))?.route
                    }/${item._id}`}
                    onClick={() => {
                      if (closeAfterClicked) {
                        toggleSidebar();
                      }
                    }}
                  >
                    {item.title}
                  </RecentChatItem>
                ))}
              </RecentChats>
            </div>
          )}
        </FolderList>
      )}
      {!topic && (
        <FolderList isOpen={openSidebar}>
          {features
            .filter((folder) => !folder.topicRequired)
            .map((folder, index) => (
              <FolderItem
                onClick={() => handleAction(folder.func)}
                key={index}
                expandDisable={folder.expandDisable && openSidebar}
              >
                {openSidebar ? folder.name : folder.icon}
              </FolderItem>
            ))}
        </FolderList>
      )}
      {userExtendData && (
        <WrapperProfile isOpen={openSidebar}>
          <Tooltip title="My Profile" placement="right">
            <img
              style={{
                width: 40,
                height: 40,
                cursor: "pointer",
                borderRadius: "50%",
              }}
              src={userExtendData?.avatarUrl || defaultAvatar}
              onClick={() => handleAction(() => navigate("/profile"))}
            />
          </Tooltip>
          <Username>
            {me?.firstName} {me?.lastName}
          </Username>
          <Dropdown
            menu={{
              items: menuItems,
              style: {
                background: "#1a1a1a",
              },
            }}
            placement="topRight"
            trigger={["click"]}
          >
            <SettingIcon style={{ cursor: "pointer" }} width={20} />
          </Dropdown>
        </WrapperProfile>
      )}
    </>
  );
};

export default SidebarContent;
